import { render, staticRenderFns } from "./dicPortDetails.vue?vue&type=template&id=46efd321&scoped=true&"
import script from "./dicPortDetails.vue?vue&type=script&lang=js&"
export * from "./dicPortDetails.vue?vue&type=script&lang=js&"
import style0 from "./dicPortDetails.vue?vue&type=style&index=0&id=46efd321&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46efd321",
  null
  
)

export default component.exports